import React, { useContext, useState } from 'react';
import { BetaContext } from '../context/BetaContext';
import { submitFeedback } from '../services/beta';
import './FeedbackModal.css';

const FeedbackModal = ({ onClose }) => {
  const { deviceId } = useContext(BetaContext);
  const [type, setType] = useState('feedback');
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [severity, setSeverity] = useState('medium');
  const [steps, setSteps] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await submitFeedback({
        type,
        title,
        body,
        severity: type === 'bug' ? severity : undefined,
        steps: type === 'bug' ? steps : undefined,
        meta: {
          platform: 'web',
          appVersion: process.env.REACT_APP_VERSION,
          deviceId
        }
      });
      setSuccess('Thanks! Your feedback was submitted.');
      setTitle('');
      setBody('');
      setSteps('');
    } catch (err) {
      setError('Failed to submit feedback.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="feedback-modal__backdrop">
      <div className="feedback-modal">
        <div className="feedback-modal__header">
          <h3>Send Beta Feedback</h3>
          <button className="feedback-modal__close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="feedback-modal__form">
          <label>
            Type
            <select value={type} onChange={(e) => setType(e.target.value)}>
              <option value="feedback">Feedback</option>
              <option value="bug">Bug</option>
              <option value="feature">Feature Request</option>
            </select>
          </label>

          <label>
            Title
            <input value={title} onChange={(e) => setTitle(e.target.value)} required />
          </label>

          <label>
            Details
            <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={4} required />
          </label>

          {type === 'bug' && (
            <>
              <label>
                Severity
                <select value={severity} onChange={(e) => setSeverity(e.target.value)}>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="critical">Critical</option>
                </select>
              </label>

              <label>
                Steps to Reproduce
                <textarea value={steps} onChange={(e) => setSteps(e.target.value)} rows={3} />
              </label>
            </>
          )}

          {error && <div className="feedback-modal__error">{error}</div>}
          {success && <div className="feedback-modal__success">{success}</div>}

          <div className="feedback-modal__actions">
            <button type="button" onClick={onClose} className="btn-secondary">Close</button>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackModal;
